import { cn } from "@/utils/cn";
import { Link, useLocation } from "react-router-dom";

export const NavLink = ({ to, children }: { to: string; children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const active = pathname === to || pathname.startsWith(`${to}/`);
  return (
    <Link
      to={to}
      aria-current={active ? "page" : undefined}
      className={cn(
        "text-sm transition-colors",
        active
          ? "text-zinc-900 font-medium cursor-default"
          : "text-zinc-500 hover:text-zinc-900",
      )}
    >
      {children}
    </Link>
  );
};